<template>
  <div v-if="availableLanguages.length > 1" class="languageSelector">
    <select @change="setLanguage($event.target.value)" :value="locale" :aria-label="t('LanguageSelection')">
      <option :key="availableLanguage" v-for="availableLanguage in availableLanguages" :value="availableLanguage">{{languageDisplayName(availableLanguage)}}</option>
    </select>
  </div>
</template>

<script src="./languageselector.ts" />
